export default "__VITE_ASSET__bae125ff__"